import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuthWithoutBody,
  headersWithAuth,
  cancelPreviousRequest,
  decryptResponse,
} from "../../../APIHelpers/Responses";

export const groupAndProjectServices = {
  addNewGroupAndProject,
  updatedGroupAndProject,
  softDeleteRestoreGroupAndProject,
  deleteGroupAndProject,
  getGroupAndProjectList,
  getSingleGroupAndProject,
  addNewMessageAndFile,
  updateMessageAndFile,
  getMessageAndFile
};

// Add New Group And Project
async function addNewGroupAndProject(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewGroupAndProject`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Group And Project
async function updatedGroupAndProject(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedGroupAndProject`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Group And Project
async function softDeleteRestoreGroupAndProject(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreGroupAndProject`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Group And Project
async function deleteGroupAndProject(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteGroupAndProject`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Group And Project
async function getGroupAndProjectList(status, category, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getGroupAndProjectList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getGroupAndProjectList/${status}/${category}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getGroupAndProjectList/${status}/${category}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Group And Project
async function getSingleGroupAndProject(gpId) {
  let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleGroupAndProject/${gpId}`;
  const response = await fetch(apiURL, headersWithAuthWithoutBody("GET", headers));
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}

// Add New Message & File
async function addNewMessageAndFile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewMessageAndFile`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  return data;
}

// Update Message & File
async function updateMessageAndFile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateMessageAndFile`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  return data;
}

// Get Message & File
async function getMessageAndFile(gpId) {
  let apiURL = `${config.API_URL_USER_ONBOARDING}getMessageAndFile/${gpId}`;
  const response = await fetch(apiURL, headersWithAuthWithoutBody("GET", headers));
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}